export default "__VITE_ASSET__Cr5sW2Ir__"